import React, { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { BsChevronRight } from 'react-icons/bs'
import ContactForm from '../contactus-popup/ContactForm'
import { SERVICE_BG } from '../../assets/images'
import './service-banner.css'

const ServiceBanner = ({ data,bg }) => {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <div className='service-banner' style={{ background: `url(${bg || SERVICE_BG})` }}>
                <Container>
                    <Row>
                        <Col lg='8' xl={6}>
                            {data.map((head, i) => {
                                return (
                                    <h1 key={i} id={head.id} className='banner-title'>{head.title}</h1>
                                )
                            }
                            )}
                            <div className='hero_section_btn sm-mt-20' onClick={handleShow}>
                                <a href="javascript:void(0)" >Get your free quote</a>
                                <span className='cursor-pointer'>  <BsChevronRight /></span>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <ContactForm show={show} onClose={handleClose} onShow={handleShow} />
        </>
    )
}

export default ServiceBanner